import { locale } from "Common/dxLocalization";
import { createGlobalStyle } from "styled-components";
import { btnDarkStyles, btnDefaultStyles, btnPrimaryDarkStyles, btnPrimaryStyles, btnStyles, btnTextRedStyles, btnTextStyles, btnArrowActionStyles, btnFilledStyles, btnDeleteRedStyles } from "./css/btnCss";
import { dxBaseStyles, dxCalendar, dxCheckBox, dxDataGrid, dxEditor, dxEditorError, dxEditorFocus, dxEditorHover, dxOverlay, dxRadioButton, dxResizable, dxRichEditor, dxScrollable, dxTagBox, dxTooltip, dxTreeView, rcVirtualList, dxIcons, dxEditorSearchPanel, dxFilterBuilder, dxReverseBtnOkCannel, dxMenu, dxColorBox } from "./css/dxCss";
import SIZES from "./css/sizes";
import themeVariables from "./themeVariables";
export default createGlobalStyle `
html
{
  ${dxBaseStyles}

  ${dxDataGrid}

  ${dxTagBox}
  ${dxCheckBox}
  ${dxRadioButton}

  ${dxTreeView}

  ${dxOverlay}

  .dx-searchbox .dx-icon-search,
  .dx-icon-search {
    &:before {
      color: ${({ theme }) => theme["gray-400"]} !important;
      content: '\\e978';
      font: ${({ theme }) => theme["icomoon-icons"]};
      font-size: 16px;
    }
  }
  .dropdown-menu .dx-searchbox .dx-icon-search,
  .dropdown-menu .dx-icon-search {
    &:before {
      color: ${({ theme }) => theme["gray-400"]} !important;
    }
  }
  .dx-searchbox .dx-icon-search {
    width: 36px;
  }
  .dx-searchbox .dx-placeholder:before,
  .dx-searchbox .dx-texteditor-input {
    padding-left: 36px;
  }

  .dx-progressbar-container {
    height: ${SIZES.PROGRESS_BAR_HEIGHT}px;
    border-radius: ${Math.floor(SIZES.PROGRESS_BAR_HEIGHT / 2)}px;
    border: 1px solid ${({ theme }) => theme["brand-primary-500"]};
    background-color: ${({ theme }) => theme["brand-primary-500"]};

    .dx-progressbar-range {
      border-radius: ${Math.floor(SIZES.PROGRESS_BAR_HEIGHT / 2)}px;
      min-width: ${SIZES.PROGRESS_BAR_HEIGHT - 2}px;
      margin-left: -1px;
    }
  }

  .dx-toolbar .dx-button,
  .dx-toolbar-item.dx-toolbar-button .dx-button,
  .dx-button:not(.dx-tabs-nav-button) {
    ${btnStyles}
    ${btnDefaultStyles}

    &.btn-primary {
      ${btnPrimaryStyles}
    }

    &.btn-primary-dark {
      ${btnPrimaryDarkStyles}
    }

    &.btn-text {
      ${btnTextStyles}
    }

    &.btn-text-red {
      ${btnTextRedStyles}
    }

    &.btn-dark {
      ${btnDarkStyles}
    }

    &.btn-arrow-action {
      ${btnArrowActionStyles}
    }

    &.btn-filled {
      ${btnFilledStyles}
    }

    &.btn-delete-red {
      ${btnDeleteRedStyles}
    }

    // the same height as input for the best vertical aligning
    height: ${({ theme }) => theme["input-height-base"]};

    &.btn-h-m {
      height: ${({ theme }) => theme["input-height-medium"]};
    }

    &.btn-h-auto {
      height:auto;
    }
  }

  .dx-button .dx-button-content .dx-button-text {
    opacity: 1;
  }

  .dx-button .dx-button-content,
  .dx-toolbar-item.dx-toolbar-button .dx-button .dx-button-content {
    line-height: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    .dx-button-submit-input {
      display: none;
    }
  }
  .dx-toolbar-item.dx-toolbar-button .dx-button {
    ${btnStyles}
    ${btnArrowActionStyles}
  }
  .dx-overlay-wrapper.dx-popup-wrapper .dx-overlay-content .dx-toolbar.dx-popup-bottom .dx-button[aria-label="${locale.OK}"],
  .dx-overlay-wrapper.dx-popup-wrapper .dx-overlay-content .dx-toolbar.dx-popup-bottom .dx-button[aria-label="${locale["dxDataGrid-headerFilterOK"]}"],
  .dx-overlay-wrapper.dx-popup-wrapper .dx-overlay-content .dx-toolbar.dx-popup-bottom .dx-button[aria-label="${locale["ASPxRichEditStringId.OkButton"]}"],
  .dx-datagrid-edit-form > .dx-master-detail-cell > .dx-datagrid-form-buttons-container >.dx-button:first-child,
  .dx-edit-row .dx-datagrid-form-buttons-container > .dx-button:first-child {
    ${btnPrimaryStyles}
  }
  .dx-datagrid-edit-form > .dx-master-detail-cell > .dx-datagrid-form-buttons-container,
  .dx-edit-row .dx-datagrid-form-buttons-container{
    float: ${themeVariables["datagrid-form-buttons-float"]};
    .dx-button {
        height: ${themeVariables["datagrid-form-buttons-height"]};
    }
  }

  .dx-list .dx-empty-message,
  .dx-list-item {
    border: 0 none;
  }
  .dx-list .dx-empty-message,
  .dx-scrollable-content .dx-empty-message {
    position: absolute;
    width: 100%;
    text-align: center;
    top: 50%;
  }
  .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-hover {
    color: ${({ theme }) => theme["dropdown-link-color"]};
    background-color: ${({ theme }) => theme["dropdown-link-hover-bg"]};
  }
  .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item {
    &.dx-state-active,
    &.dx-list-item-selected,
    &.dx-list-item-selected.dx-state-active,
    &.dx-list-item-selected.dx-list-item-focused,
    &.dx-list-item-selected.dx-state-focused,
    &.dx-list-item-selected.dx-state-hover,
    &.dx-list-item-selected.dx-state-hover:not(.dx-state-focused),
    &.dx-state-active.dx-list-item-focused {
      color: ${({ theme }) => theme["dropdown-link-color"]};
      background-color: ${({ theme }) => theme["dropdown-link-active-bg"]};
    }
  }

  .dx-editor-cell .dx-texteditor,
  .dx-editor-cell .dx-texteditor .dx-texteditor-input {
    background-color: transparent;
  }
  .dx-dropdowneditor.dx-state-active,
  .dx-dropdowneditor.dx-dropdowneditor-active {
    box-shadow: ${({ theme }) => theme["btn-default-shadow-active"]};
  }
  .dx-dropdowneditor-button.dx-button-mode-contained,
  .dx-dropdowneditor.dx-state-active .dx-dropdowneditor-icon,
  .dx-dropdowneditor.dx-state-hover:not(.dx-custom-button-hovered) .dx-dropdowneditor-icon,
  .dx-dropdowneditor-button.dx-state-active .dx-dropdowneditor-icon,
  .dx-dropdowneditor.dx-dropdowneditor-active .dx-dropdowneditor-icon {
    color: ${({ theme }) => theme["text-color"]};
    background-color: transparent;
    border: 1px solid transparent;
  }

  .dx-datebox-wrapper-calendar .dx-calendar {
    margin: 0;
  }

  ${dxScrollable}

  .dx-icon-download:before {
    content: '\\e910';
    font: ${({ theme }) => theme["icomoon-icons"]};
    font-size: 13px;
  }
  .dx-icon-trash:before {
    content: '\\e90e';
    font: ${({ theme }) => theme["icomoon-icons"]};
    font-size: 13px;
  }
  .dx-icon-edit:before {
    content: '\\e911';
    font: ${({ theme }) => theme["icomoon-icons"]};
    font-size: 13px;
  }
  .dx-icon-comments:before {
    content: '\\e95d';
    font: ${({ theme }) => theme["icomoon-icons"]};
    font-size: 13px;
  }
  .dx-icon-like:before {
    content: '\\e95e';
    font: ${({ theme }) => theme["icomoon-icons"]};
    font-size: 13px;
  }

  .dx-selectbox .dx-dropdowneditor-icon,
  .dx-dropdowneditor-icon {
    transform: rotate(180deg);
  }

  .dx-selectbox .dx-dropdowneditor-icon:before,
  .dx-dropdowneditor-icon:before {
    color: ${({ theme }) => theme["gray-500"]};
    content: '\\e902';
    display: block;
    font: ${({ theme }) => theme["icomoon-icons"]};
    font-size: 16px;
    width: 16px;
    font-weight: 500;
    transition: all 0.2s linear;
    transform: rotate(0);
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon {
    transform: unset !important;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon:before {
    color: ${({ theme }) => theme["gray-500"]};
    content: '\\e979';
    display: block;
    font: ${({ theme }) => theme["icomoon-icons"]};
    font-size: 16px;
    width: 16px;
    font-weight: 500;
    transform: unset !important;
  }

  .dx-selectbox .dx-dropdowneditor-active .dx-dropdowneditor-icon:before,
  .dx-dropdowneditor-active .dx-dropdowneditor-icon:before {
    transform: rotate(180deg);
  }
  .dx-numberbox-spin-up-icon:before,
  .dx-numberbox-spin-down-icon:before {
    content: '\\e902';
    display: block;
    font: ${({ theme }) => theme["icomoon-icons"]};
    font-size: 14px;
    color: ${({ theme }) => theme["text-color"]};
  }
  .dx-numberbox-spin-up-icon:before,
  .dx-numberbox-spin-down-icon:before {
    margin-top: -7px;
    margin-left: -9px;
  }
  .dx-numberbox-spin-down-icon:before {
    transform: scale(1, -1);
  }
  .dx-state-hover.dx-numberbox-spin-button .dx-numberbox-spin-down-icon,
  .dx-state-hover.dx-numberbox-spin-button .dx-numberbox-spin-up-icon {
    background-color: ${({ theme }) => theme["gray-100"]};
    color: ${({ theme }) => theme["text-color"]};
  }
  .dx-state-active.dx-numberbox-spin-button .dx-numberbox-spin-down-icon,
  .dx-state-active.dx-numberbox-spin-button .dx-numberbox-spin-up-icon {
    background-color: ${({ theme }) => theme["gray-100"]};
    color: ${({ theme }) => theme["text-color"]};
    box-shadow: ${({ theme }) => theme["btn-default-shadow-active"]};
  }
  .dx-editor-with-menu > .dx-editor-container > .dx-texteditor.dx-datebox-calendar .dx-dropdowneditor-icon:before {
    color: ${({ theme }) => theme["gray-500"]};
  }
  .dx-selectbox.dx-dropdowneditor-active .dx-dropdowneditor-button > .dx-button-content > .dx-dropdowneditor-icon {
    transform: scale(1, -1);
  }
  .dx-context-menu-container-border {
    border: 1px solid ${({ theme }) => theme["input-border"]};
    box-shadow: none;
  }
  .dx-context-menu .dx-submenu {
    border: 1px solid ${({ theme }) => theme["input-border"]};
    box-shadow: ${({ theme }) => theme["dropdown-box-shadow"]};
    border-radius: ${({ theme }) => theme["border-radius-base"]};
  }
  .dx-popup-wrapper .dx-state-focused.dx-overlay-content {
    border: 1px solid ${({ theme }) => theme["input-border"]};
  }
  .dx-context-menu .dx-menu-items-container {
    padding: 0;
    border-radius: ${({ theme }) => theme["border-radius-base"]};
  }

  .dx-overlay-wrapper .dx-menu-base .dx-menu-item-content {
    padding: 8px 12px 10px;
  }
  .dx-menu-item.dx-menu-item-has-text .dx-icon {
    margin-right: -12px;
    margin-top: -2px;
  }
  .dx-menu-item {
    color: ${({ theme }) => theme["dropdown-link-color"]};
    text-decoration: none;
    outline: 0;
  }
  .dx-menu-item.dx-state-hover,
  .dx-menu-item.dx-state-focused {
    color: ${({ theme }) => theme["dropdown-link-color"]};
    background-color: ${({ theme }) => theme["dropdown-link-hover-bg"]};
  }
  .dx-menu-item-selected {
    color: ${({ theme }) => theme["dropdown-link-active-color"]};
    background-color:${({ theme }) => theme["dropdown-link-active-bg"]};
  }
  .dx-menu-base .dx-menu-item-wrapper {
    > .dx-item {
      z-index: 2001;
    }
    &:first-child > .dx-item{
      border-top-left-radius: ${({ theme }) => theme["border-radius-base"]};
      border-top-right-radius: ${({ theme }) => theme["border-radius-base"]};
    }
    &:last-child > .dx-item {
      border-bottom-left-radius: ${({ theme }) => theme["border-radius-base"]};
      border-bottom-right-radius: ${({ theme }) => theme["border-radius-base"]};
    }
  }

  ${dxCalendar}

  .dx-toolbar-item.dx-toolbar-button .dx-button.dx-closebutton {
    &,
    &:active,
    &.active,
    &:focus,
    &:hover,
    &.dx-state-hover {
      width: 26px;
      height: 26px;
      padding: 0;
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }

    opacity: 0.6;
    transition: opacity 0.15s;
    &:hover {
      opacity: 1;
    }

    .dx-icon-close {
      font-size: 14px;
      width: 16px;
      height: 16px;
      background-size: 16px 16px;
      line-height: 16px;
      &:before {
        color: ${({ theme }) => theme["text-color"]} !important;
        font-size: 14px;
      }
    }
  }

  .dx-slider.dx-widget {
    line-height: 1;
  }

  .dx-slider-wrapper {
    .dx-slider-bar {
      background: ${({ theme }) => theme["gray-200"]};
      margin: ${(SIZES.SLIDER_HANDLE_SIZE + SIZES.SLIDER_HANDLE_BORDER * 2 - SIZES.SLIDER_BAR_HEIGHT) / 2}px 0;
      height: ${SIZES.SLIDER_BAR_HEIGHT}px;
    }
    height: ${SIZES.SLIDER_HANDLE_SIZE * 2}px;

    .dx-slider-range {
      box-sizing: border-box;
      height: ${SIZES.SLIDER_BAR_HEIGHT}px;
    }

    .dx-slider-range.dx-slider-range-visible {
      border: 3px solid ${({ theme }) => theme["brand-primary-500"]};
      background: ${({ theme }) => theme["brand-primary-500"]};

      .dx-slider-handle {
        margin-top: -${(SIZES.SLIDER_HANDLE_SIZE + SIZES.SLIDER_HANDLE_BORDER + 2) / 2}px;
        margin-right: -${SIZES.SLIDER_HANDLE_SIZE}px;
        width: ${SIZES.SLIDER_HANDLE_SIZE}px;
        height: ${SIZES.SLIDER_HANDLE_SIZE}px;
        border: ${SIZES.SLIDER_HANDLE_BORDER}px solid ${({ theme }) => theme["brand-primary-500"]};
        background-color: #fff;
        border-radius: 50%;
      }
    }
  }

  .dx-tabs-scrollable .dx-tabs-wrapper,
  .dx-tabs-wrapper {
    border: 0;
  }

    .dx-tabs-wrapper{
        display: flex !important;
        gap: 8px;
    }

  .dx-tabs-scrollable {
    height: 100%;
    margin-top: 0;
    margin-bottom: 0;
  }

  .dx-tabs .dx-tabs-nav-button {
    box-shadow: none !important;
    &, &.dx-state-focus {
      background-color: ${({ theme }) => theme["body-bg"]};
      color: ${({ theme }) => theme["btn-default-color"]};
      .dx-icon {
        color: ${({ theme }) => theme["btn-default-color"]};
        font-size: ${({ theme }) => theme["font-size-base"]};
      }
    }

    &.dx-state-hover {
      background-color: ${({ theme }) => theme["gray-050"]};
      color: ${({ theme }) => theme["btn-default-color-hover"]};
      .dx-icon {
        color: ${({ theme }) => theme["btn-default-color-hover"]};
      }
    }

    &.dx-state-active {
      background-color: ${({ theme }) => theme["btn-default-bg-active"]};
      border-color: ${({ theme }) => theme["btn-default-border-active"]};
      color: ${({ theme }) => theme["btn-default-color-active"]};
      .dx-icon {
        color: ${({ theme }) => theme["btn-default-color-active"]};
      }
    }
  }
    

    .dx-tabs {
        display: block;
        background-color: transparent;
        box-shadow: none !important;
        border-bottom:  ${({ theme }) => theme["tab-item-border"]};
    .dx-tab {
        padding: 0 !important;
        border-radius:  ${({ theme }) => theme["border-radius-medium"]};
      &:hover {
          background-color: ${({ theme }) => theme["tab-item-bg-hover"]};
      }
      &.dx-tab-selected {
        background-color: transparent;
          box-shadow: none;
      }
      .dx-icon {
        line-height: inherit;
          margin: 0 !important;
          color: ${({ theme }) => theme["gray-400"]} !important;
      }
      &.dx-tab-selected:after {
        display: none;
      }
    }
  }

  .dx-tabpanel:not(.dx-ribbon) > .dx-tabpanel-tabs .dx-tabs {
    border: ${({ theme }) => theme["tab-panel-tab-border"]};
    border-radius: ${({ theme }) => theme["tab-panel-tab-border-radius"]};
    box-shadow: ${({ theme }) => theme["tab-panel-tab-shadow"]} !important;
  }
  .dx-tabpanel:not(.dx-ribbon) > .dx-tabpanel-tabs .dx-tab {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme["tab-panel-tab-bg"]} !important;
    height: ${({ theme }) => theme["tab-panel-tab-height"]};
    font-size: ${({ theme }) => theme["tab-panel-tab-font-size"]};
    border-bottom: ${({ theme }) => theme["tab-panel-tab-border"]}  !important;
    border-radius: ${({ theme }) => theme["tab-panel-tab-border-radius"]};
    box-shadow: ${({ theme }) => theme["tab-panel-tab-shadow"]} !important;
  }
  .dx-tabpanel:not(.dx-ribbon) > .dx-tabpanel-tabs .dx-tab.dx-state-hover {
    border-color: ${({ theme }) => theme["tab-panel-tab-border-color-hover"]} !important;
    box-shadow: ${({ theme }) => theme["tab-panel-tab-shadow-hover"]} !important;
  }
  .dx-tabpanel:not(.dx-ribbon) > .dx-tabpanel-tabs .dx-tab.dx-state-focused,
  .dx-tabpanel:not(.dx-ribbon) > .dx-tabpanel-tabs .dx-tab.dx-state-active,
  .dx-tabpanel:not(.dx-ribbon) > .dx-tabpanel-tabs .dx-tab.dx-tab-selected {
    border-color: ${({ theme }) => theme["tab-panel-tab-border-color-active"]} !important;
    box-shadow: ${({ theme }) => theme["tab-panel-tab-shadow-active"]} !important;
  }
  .dx-tabpanel .dx-multiview-wrapper.dx-state-focused,
  .dx-tabpanel .dx-multiview-wrapper {
    border-color: ${({ theme }) => theme["gray-100"]};
  }

  .dx-field-item-label-text {
    color: ${({ theme }) => theme["gray-500"]};
    font-size: ${({ theme }) => theme["font-size-small"]};
  }

  .dx-field-item-required .dx-label > span:after,
  .dx-field-item-required-mark {
    color: ${({ theme }) => theme["brand-danger-500"]};
  }

  .dx-buttongroup-item.dx-button.dx-button-mode-text.dx-button-normal {
    &.dx-item-selected {
      color: ${({ theme }) => theme["text-color"]};
      background-color: ${({ theme }) => theme["gray-050"]};
      box-shadow: inset 0px 3px 5px -2px ${({ theme }) => theme["gray-400"]};
    }
  }

  .form-group-content-hidden .dx-form-group-content {
    display: none;
  }

  .dx-form-group-caption {
    font-size: ${({ theme }) => theme["font-size-h5"]};
    font-weight: 700;
  }

  ${dxResizable}

  ${rcVirtualList}

  ${dxRichEditor}

  .dx-button-mode-contained .dx-icon {
    color: inherit;
  }

  ${dxEditor}
  ${dxEditorHover}
  ${dxEditorFocus}
  ${dxEditorError}
  ${dxEditorSearchPanel}
  ${dxTooltip}
  ${dxIcons}
  ${dxMenu}
  ${dxFilterBuilder}
  ${dxReverseBtnOkCannel}
  ${dxColorBox}
`;
